<template>
  <a-radio-group
    :value="selectedCycleId"
    button-style="solid"
    size="small"
    @change="event => onSelectCycle(event.target.value)"
  >
    <a-radio-button
      value="prev"
      :disabled="isPrevDisabled"
    >
      <LeftOutlined />
    </a-radio-button>
    <a-radio-button
      :key="selectedCycle.id"
      :value="selectedCycle.id"
    >
      {{ selectedCycle.displayName }}
    </a-radio-button>
    <a-radio-button
      value="next"
      :disabled="isNextDisabled"
    >
      <RightOutlined />
    </a-radio-button>
  </a-radio-group>
</template>

<script>
import { computed, toRefs } from 'vue'
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
export default {
  components: {
    LeftOutlined,
    RightOutlined
  },
  props: {
    selectedCycleId: {
      type: Number,
      default: () => dayjs().quarter()
    }
  },
  emits: ['update:selectedCycleId'],
  setup (props, { emit }) {
    // const selectedCycleId = ref(dayjs().quarter())
    const { t } = useI18n()
    const { selectedCycleId } = toRefs(props)
    const cycles = computed(() => ([
      {
        id: 1,
        displayName: `${t('weekly.quarters.0')}`
      },
      {
        id: 2,
        displayName: `${t('weekly.quarters.1')}`
      },
      {
        id: 3,
        displayName: `${t('weekly.quarters.2')}`
      },
      {
        id: 4,
        displayName: `${t('weekly.quarters.3')}`
      }
    ]))

    function onSelectCycle (id) {
      if (id === 'prev') {
        emit('update:selectedCycleId', selectedCycleId.value - 1)
        // selectedCycleId.value -= 1
      } else if (id === 'next') {
        emit('update:selectedCycleId', selectedCycleId.value + 1)
        // selectedCycleId.value += 1
      }
    }

    const isPrevDisabled = computed(() => selectedCycleId.value === 1)
    const isNextDisabled = computed(() => selectedCycleId.value === 4)

    return {
      selectedCycle: computed(() => cycles.value[selectedCycleId.value - 1]),
      // selectedCycleId,
      isPrevDisabled,
      isNextDisabled,
      cycles,
      onSelectCycle
    }
  }
}
</script>
